import { FAQ } from "../content/faq";
import "./styles/FaqList.css";

export function FaqList() {
  return (
    <div className="faq__list">
      {FAQ.map((item) => (
        <details key={item.question} className="faq__item">
          <summary>{item.question}</summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  );
}
